// @ts-expect-error - vite/modulepreload-polyfill is not typed
import 'vite/modulepreload-polyfill';
import './main.css';

import React from 'react';
import { makeR2wc } from './utils/make-r2wc';
import { ImageUploadField } from './organisms/image-upload-field/ImageUploadField.tsx';
import { TiptapEditorField } from './organisms/tiptap-editor-field/TiptapEditorField.tsx';

// Legacy components
import { ButtonBox } from './organisms/legacy/ButtonBox';
import { EnableAutoMatching } from './organisms/legacy/EnableAutoMatching';
import { RestartSearchCatchup } from './organisms/legacy/RestartSearchCatchup';
import { ActivityCardFactory } from './organisms/activity-card/ActivityCardFactory.tsx';
import { SondageManager } from './organisms/sondage-manager/SondageManager.tsx';

const register = makeR2wc({
  context: React.Fragment,
  className: 'hektor',
});

// Legacy components registration
register('x-button-box', ButtonBox, {
  clusters: 'string',
  surveys: 'string',
});

register('x-enable-auto-matching', EnableAutoMatching, {
  instance: 'string',
});

register('x-restart-search-catchup', RestartSearchCatchup, {
  instance: 'string',
});

register('x-image-upload-field', ImageUploadField, {
  fileNameFieldId: 'string',
  fileFieldId: 'string',
  onValueChange: 'function',
});

register('x-tiptap-editor-field', TiptapEditorField, {
  htmlFieldId: 'string',
  jsonFieldId: 'string',
  onValueChange: 'function',
});

register('x-sondage-manager', SondageManager, {});

register('x-activity-card-factory', ActivityCardFactory, {
  type: 'string',
  title: 'string',
  content: 'string',
  jsonContent: 'string',
  fileSrc: 'string',
  fileName: 'string',
  redirectionUrl: 'string',
  pinned: 'boolean',
});
